module.exports = (__webpack_public_path__ || '') + "static/images/apple-touch-icon-114x114-fe764066dca66afe9f21a7641a28d412.png";